import { atom } from "jotai";
import { MapProjection, MapTile } from "@oreme/ui";
import { mapProjections, mapTiles } from "@/utils";

export const mapTileAtom = atom<MapTile>(mapTiles.get("OSMBright") as MapTile);
export const mapProjectionAtom = atom<MapProjection>(
  mapProjections.get("globe") as MapProjection,
);
